import React, { FC } from "react";
import { Backplate, Text } from "./style";
import { StyledAnchorLink } from "../buttons/default.style";

const LearnMore: FC = () => {
    return (
        <Backplate>
            <Text>
                Want to learn more? Schedule a consultation with our climate experts and learn more
                about how we could help your financial institution to better address the climate
                risks!
            </Text>
            <StyledAnchorLink to='/#demo'>CONTACT US</StyledAnchorLink>
        </Backplate>
    );
};

export default LearnMore;
